import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Location  {
    _originalTypeClassName = "zERP.BO.Location";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Location.translate = translateService;
}
this.Floors = [];
this.Id = null;
this.Number = null;
this.Name = null;
this.Notes = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Number:any;
Name:any;
Notes:any;
Code:any;
Floors:any;
Address:any;
static setFloors = ($this, items) => {
                if (items == null) items = [];
                if ($this.Floors == null) $this.Floors = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Floors.length > 0) {
                    Domain.Location.removeFloors($this, $this.Floors[0]);
                }

                Domain.Location.addManyFloors($this, copyItems);
            }
static addManyFloors = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Location.addFloors($this, items[i]);
                }
            }
static addFloors = ($this, item) => {
                if ($this.Floors == null) $this.Floors = [];
                if (item == null || $this.Floors.indexOf(item) > -1) return;
                $this.Floors.push(item);
if (item.Location != $this) {
Domain.Floor.setLocation(item, $this);
}
}
static addRangeFloors = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Location.addFloors($this, item));
            }
static removeFloors = ($this, item) => {
                if ($this == null || $this.Floors == null || $this.Floors.indexOf(item) === -1) return;
                var _index = $this.Floors.indexOf(item);
                $this.Floors.splice(_index, 1);
item.Location = null;
}
static clearFloors = ($this) => { $this.Floors = null; }
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}

static GetClassName(): any{return "Location";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}